var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{class:['grid--container', `${_vm.name}__grid`, `${_vm.name}__main`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        alignContent: 'center',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
        alignContent: 'center',
      },
    ]}},[_c('grid-item',{class:`${_vm.name}__grid-item`,attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},[_vm._l((_vm.cms.header),function(item,index){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:index,tag:"component",class:`${_vm.name}__header`,attrs:{"cms":item}})}),_vm._v(" "),_c('fetch-story',{attrs:{"route":_vm.cms.api_endpoint || '',"params":{
          sort_by: _vm.cms.api_order || null,
          by_uuids: _vm.cms.api_filter || null,
        },"limit":parseInt(_vm.cms.api_limit || 0),"offset":parseInt(_vm.cms.api_offset || 0),"collection":_vm.cms.collection,"entry":"content"},scopedSlots:_vm._u([{key:"default",fn:function({ collection }){return _c('div',{class:`${_vm.name}__content`},_vm._l((collection),function(item,index){return _c('div',{key:index,class:[`${_vm.name}__item`]},[(!item.thumbnails)?_c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],tag:"component",class:`${_vm.name}__card`,attrs:{"cms":item,"url":_vm.setCtaUrl(item.cta),"layout":[
                { size: 0, bound: 311, ratio: [311, 212] },
                { size: 1, bound: 425, ratio: [425, 290] },
                { size: 2, bound: 425, ratio: [425, 290] },
                { size: 3, bound: 425, ratio: [425, 290] },
              ]}}):_vm._e(),_vm._v(" "),_vm._l((item.thumbnails),function(thumb,t_index){return _c('m-card',{directives:[{name:"editable",rawName:"v-editable",value:(thumb),expression:"thumb"}],key:t_index,class:`${_vm.name}__card`,attrs:{"cms":{
                ...thumb,
                cta: _vm.cms.cta,
                podcast: !!item.component.includes('podcast'),
              },"url":item.url,"layout":[
                { size: 0, bound: 311, ratio: [311, 212] },
                { size: 1, bound: 425, ratio: [425, 290] },
                { size: 2, bound: 425, ratio: [425, 290] },
                { size: 3, bound: 425, ratio: [425, 290] },
              ]}})})],2)}),0)}}])})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }